export enum ProcessingSteps {
  AT_SETUP = 1,
  AT_REVIEW,
  PROD_SETUP,
  PROD_REVIEW,
  PP_SETUP,
}
